<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";

import Profile from "@/components/widgets/profile";
import Earning from "@/components/widgets/earning";
import Stat from "@/components/widgets/stat";
import Transaction from "@/components/widgets/transaction";
import Emailsent from "@/components/widgets/emailsent";

/**
 * Dashboard Component
 */
export default {
  page: {
    title: "Dashboard",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: {
  },
  data() {
    return {
      title: "Pembayaran",
      items: [
        {
          text: "Dashboards",
          href: "/"
        },
        {
          text: "Default",
          active: true
        }
      ],
      data : [
        {
          picked: null
        }
      ],
    };
  }
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

  <nav class="navbar navbar-expand-lg navigation sticky" id="navbar">
    <div class="container">
      <a class="navbar-logo" href="/">
        <img src="@/assets/images/gurukreator.png" alt="paideia education solution" height="40" margin-top="10" class="logo logo-dark" />
        <img src="@/assets/images/gurukreator.png" alt="paideia education solution" height="40" margin-top="10" class="logo logo-light" />
      </a>
    </div>
  </nav>

    <div class="row">
      <div class="col-xl-6">
        <div class="vertical-nav">
          <b-card-text>
            <div class="card"
                 style= "
                        	border-radius: 8px;
	                        box-shadow: 1px 2px 8px rgba(0, 0, 0, 0.10);
                	        margin: 6rem auto 8.1rem auto;
                        " 
            >
            <b-card-body
                  style= "
                          padding: 55px 44px;
                         "
            >
              <div class="text-center">
                <h4 class="mb-5">Pembayaran Berhasil!</h4>
                <img src="@/assets/images/checklist.png" alt="" width="100px" height="100px">
                <p style="font-size:1em;" class="mt-5">Pesanan #GK0056</p><br><br>
                <hr>
              </div>
              <div>
                <p style="font-size:1em;">Receipt</p>
                <p style="font-size:1em;">Akun</p>
                <p style="font-size:1em;">Pembayaran</p>
                <hr>
              </div>
              <div>
                <p style="font-size:1.1em"><b>Monthly</b></p><br>
              </div>
              <div>
                <p style="font-size:1em;">Subtotal</p>
              </div><br><br>
              <div class="text-center">
                <p style="font-size:1em;"><snap class="blue-paideia"><a>Klik Disini</a></snap> untuk kembali ke aplikasi</p>
              </div>
            </b-card-body>
            </div>
          </b-card-text>
        </div>
      </div>
      <!-- end col -->
      
    </div>
    <!-- end row -->
  </Layout>
</template>